<template>
	<div
		v-if="type === 'primary'"
		:class="['share-post-links', { 'mb-[24px]': !isAlternative }]"
	>
		<NuxtLink
			:to="`http://www.facebook.com/sharer.php?u=${postUrl}`"
			class="share-btn"
			aria-label="Share on Facebook"
		>
			<img
				width="16"
				height="16"
				class="fb-i"
				src="/images/facebook-i.svg"
				alt=""
			/>
		</NuxtLink>
		<NuxtLink
			:to="`http://twitter.com/share/?url=${postUrl}&text=&via=timothysykes`"
			class="share-btn"
			aria-label="Share on Twitter"
		>
			<img
				width="16"
				height="16"
				src="/images/twitter-i.svg"
				alt=""
			/>
		</NuxtLink>
		<NuxtLink
			aria-label="Share on LinkedIn"
			:to="`http://www.linkedin.com/shareArticle?mini=true&url=${postUrl}`"
			class="share-btn"
		>
			<img
				width="16"
				height="16"
				src="/images/linkedin-i.svg"
				alt=""
			/>
		</NuxtLink>

		<NuxtLink
			aria-label="Share through Email"
			class="share-btn"
			:to="`mailto:?subject=Check%20out%20this%20link&body=Hey%20there,%0A%0ACheck%20out%20this%20link:%20${postUrl}`"
		>
			<img
				width="16"
				height="16"
				src="/images/mail-i.svg"
				alt=""
			/>
		</NuxtLink>
	</div>
	<div
		v-else
		class="share-post-links filled mb-[24px]"
	>
		<span class="label">Share</span>
		<NuxtLink
			:to="`http://www.facebook.com/sharer.php?u=${postUrl}`"
			class="share-btn"
		>
			<img
				class="fb-i"
				src="/images/facebook-i.svg"
				alt=""
			/>
		</NuxtLink>
		<NuxtLink
			:to="`http://twitter.com/share/?url=${postUrl}&text=&via=timothysykes`"
			class="share-btn"
		>
			<img
				src="/images/twitter-i.svg"
				alt=""
			/>
		</NuxtLink>
		<NuxtLink
			:to="`http://www.linkedin.com/shareArticle?mini=true&url=${postUrl}`"
			class="share-btn"
		>
			<img
				src="/images/linkedin-i.svg"
				alt=""
			/>
		</NuxtLink>

		<NuxtLink
			class="share-btn"
			:to="`mailto:?subject=Check%20out%20this%20link&body=Hey%20there,%0A%0ACheck%20out%20this%20link:%20${postUrl}`"
		>
			<img
				src="/images/mail-i.svg"
				alt=""
			/>
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
type Props = {
	type: "primary" | "secondary";
	isAlternative?: boolean;
};

withDefaults(defineProps<Props>(), { type: "primary" });

const router = useRoute();

const {
	public: { current_hostname }
} = useRuntimeConfig();

const postUrl = ref(current_hostname + router.path.slice(1));
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

.share-post-links {
	display: flex;
	gap: 16px;
}
.share-post-links.filled {
	justify-content: center;
	align-items: center;
	background-color: $primary-50;
	border-radius: 8px;
	border: 2px solid white;
	padding: 24px;
}

.share-post-links .share-btn {
	background-color: $primary-700;
	height: 36px;
	width: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 24px;

	img {
		width: 16px;
	}
}

.fb-i {
	width: 9px !important;
}

.label {
	color: #000;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
}
</style>
